export default __webpack_public_path__ + "static/media/s8.85efb148.png";